import { useTranslation } from 'react-i18next';

import { useRouteDocumentTitle } from '@client/toolkit';

import { PortfolioPaths } from '../../portfolio.router';
import { BuildingWizard } from './building-wizard';

/**
 * Route entry for <c>/portfolio/buildings/create</c>. Replaces the legacy
 * single-form <c>BuildingCreateRoute</c> with the multi-step wizard that posts
 * to <c>/buildings/bulk</c>.
 */
export function BuildingCreateRoute() {
  const { t } = useTranslation('rentalObjects');
  useRouteDocumentTitle(t('buildingAdd.title'), PortfolioPaths.BuildingCreate);

  return <BuildingWizard />;
}
